// extracted by mini-css-extract-plugin
export default {"advertising":"Advertising_advertising__ZNBPc"};